import React from 'react';
import LineColumnArea from './LineColumnArea';

import {Card, CardBody, Col} from "reactstrap";

import {OverViewData} from '../../CommonData/Data/index';


const OverView = () => {
    return (
        <React.Fragment>
            <Col xl={8}>
                <Card className="dashboard-widget">
                    <CardBody>
                        <div className="widget-header">
                            <div>
                                <h5 className="widget-title">Valuation Overview</h5>
                                <p className="widget-copy">Trend line across current workload and recent execution volume.</p>
                            </div>
                            <div className="widget-segmented">
                                    <button type="button" className="btn btn-light btn-sm">
                                        ALL
                                    </button>
                                    <button type="button" className="btn btn-primary btn-sm">
                                        1M
                                    </button>
                                    <button type="button" className="btn btn-light btn-sm">
                                        6M
                                    </button>
                                    <button type="button" className="btn btn-light btn-sm">
                                        1Y
                                    </button>
                            </div>
                        </div>
                        <div>
                            <LineColumnArea />
                        </div>
                    </CardBody>
                    <CardBody>
                        <div className="overview-legend">
                            {OverViewData.map((item, key) => (
                                <div key={key} className="overview-legend-item">
                                    <span className={`overview-legend-dot bg-${item.color}`}></span>
                                    <span>{item.title}</span>
                                </div>
                            ))}
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default OverView;
